import React from "react";

const HoneyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="currentColor" strokeMiterlimit="10">
      <path d="M6.6454 15.2291h5.2252l2.609-4.5227-2.609-4.5156H6.6454l-2.609 4.5156 2.609 4.5227Z" />
      <path d="M14.5513 10.7064h5.218l2.609-4.5156-2.609-4.5228h-5.218l-2.609 4.5228 2.609 4.5156Z" />
      <path d="m14.5226 10.7064 4.7593-.8602 2.3366-3.6554-2.609-4.5228h-4.4869l-2.609 4.5228 2.609 4.5156Z" />
      <path d="m14.5226 19.7519 4.7593-.8601 2.3366-3.6627-2.609-4.5227h-4.4869l-2.609 4.5227 2.609 4.5228Z" />
      <path d="m6.6239 24.2675 4.7593-.8601 2.3295-3.6555-2.609-4.5228H6.6239l-2.609 4.5228 2.609 4.5156Z" />
      <path d="m6.6239 15.2291 4.7593-.8601 2.3295-3.6626-2.609-4.5156H6.6239l-2.609 4.5156 2.609 4.5227Z" />
      <path d="M6.6239 24.2675h5.218l2.609-4.5156-2.609-4.5228h-5.218l-2.609 4.5228 2.609 4.5156Z" />
      <path d="M14.5226 19.7519h5.218l2.6162-4.5228-2.6162-4.5227h-5.218l-2.609 4.5227 2.609 4.5228Z" />
    </g>
  </svg>
);

export default HoneyIcon;
